import React, {Component} from 'react';
import {Platform, StyleSheet, View, Text, Dimensions} from 'react-native'
import { JDText, JDDevice } from '@jdreact/jdreact-core-lib'
import PropTypes from "prop-types"
import VideoPlayerWeb from './videoPlayer_web';

// import {WebSwiperStyle} from '../../../../utils/ut.web'


const {width, height} = Dimensions.get('window');

export default class WebSwiper extends Component {
	static propTypes = {
		imgSwiperData: PropTypes.array,
		currentPage: PropTypes.number,
		toClickHouseImg: PropTypes.func,
		imgWrapperWebStyle: PropTypes.object,
		imgWebStyle: PropTypes.object,
		indicatorWebStyle: PropTypes.object,
		isVR: PropTypes.bool,
		onIndexChanged: PropTypes.func,
		surfacePlot:PropTypes.string,
		playUrl:PropTypes.string
	};
	constructor (props) {
		super(props);
		this.state = {
			lastImgSwiperData: [],
			swiperRef: null,
			videoIndex: null
		};
		this.imgSwiper = null;
	}
	componentDidMount () {
		const { onIndexChanged,isVR,isVideo } = this.props
		let currentPage = this.props.currentPage || "";
		// WebSwiperStyle();
		// WebSwiperJS().then(() => {
			this.imgSwiper = new Swiper('.swiper-container', {
				direction : 'horizontal',
				initialSlide: currentPage || 0,
				observer:true,//修改swiper自己或子元素时，自动初始化swiper
				observeParents:false,//修改swiper的父元素时，自动初始化swiper
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
				},
				on: {
					slideChange: function () {
						onIndexChanged && onIndexChanged(this.activeIndex);
					}
				}
			})
		this.setState({
			swiperRef: this.imgSwiper
		})
		if(isVR && isVideo){
			this.setState({videoIndex: 1})
		}else if(isVideo){
			this.setState({videoIndex: 0})
		}else{
			return;
		}
		// });
	}
	outControlPlay = () => {
		this.videoPlayerWeb && this.videoPlayerWeb.outControlPlay && this.videoPlayerWeb.outControlPlay();
	}
	outControlPause = () => {
		this.videoPlayerWeb && this.videoPlayerWeb.outControlPause && this.videoPlayerWeb.outControlPause();
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps.imgSwiperData.toString() !== this.state.lastImgSwiperData.toString() && this.imgSwiper) {
			this.setState({lastImgSwiperData: prevProps.imgSwiperData});
			this.imgSwiper.updateSlides && this.imgSwiper.updateSlides();
			this.imgSwiper && this.imgSwiper.slideTo && this.imgSwiper.slideTo(0, 0);
		}
	}


	render() {
		const { imgSwiperData, imgWrapperWebStyle, imgWebStyle, indicatorWebStyle, isVR, showVR,isVideo,activeVideo,playUrl,surfacePlot } = this.props;
		const {videoIndex} = this.state;
		return (
				<div>
					{
						imgSwiperData && imgSwiperData.length > 0 && (
								<div className="swiper-container" style={styles.swiperContainer}>
									<div className="swiper-wrapper">
										{
											imgSwiperData.map((item, index) => {
												if(isVR && index === 0 && showVR){
													return (
														<div className="swiper-slide" style={ imgWrapperWebStyle } key={'webSwiper_'+index} onClick={() => this.props.toClickHouseImg(index)}>
															<img src={item} className="vr-image auto"></img>
															<div className="vr-icon"></div>
														</div>
													)
												} 
												if(isVideo && index === videoIndex ){
													return (
														<div className="swiper-slide" style={ imgWrapperWebStyle } key={'video_'+index}>
															<VideoPlayerWeb ref={(_) => {this.videoPlayerWeb = _}} surfacePlot={surfacePlot} playUrl={playUrl}/>
														</div>
													)
												}
												return (
													<div className="swiper-slide" style={ imgWrapperWebStyle } key={'webSwiper_'+index} onClick={() => this.props.toClickHouseImg(index)}>
														<img src={item} style={imgWebStyle}></img>
													</div>
												)
											})
										}
									</div>
									{/*{*/}
										{/*imgSwiperData.length > 1 && (*/}
												{/*<div className="swiper-pagination" style={indicatorWebStyle}></div>*/}
										{/*)*/}
									{/*}*/}
									<div className={["swiper-pagination",activeVideo && "hiddenPagination"].join(' ')} style={{...indicatorWebStyle, ...(imgSwiperData.length <= 1?styles.noPagination:null)}}></div>
								</div>
						)
					}

				</div>
		)
	}
}
const styles = StyleSheet.create({
	swiperContainer: {
		width: '100%',
		position: "relative"
	},
	imgWrapper: {
		width: width,
		backgroundColor:'#f4f4f4',
		// height: JDDevice.getRpx(420),

	},
	image : {
		display: 'flex',
		alignItems: 'center',
		width,
		resizeMode: 'contain',
		backgroundColor: '#f4f4f4'
	},
	noPagination: {
		display:'none'
	},
	
});